"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("@material-ui/core/Button");
const Grid_1 = require("@material-ui/core/Grid");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const types_1 = require("@pbl/pbl-react-core/lib/models/survey/pbl/types");
const classnames_1 = require("classnames");
const react_i18next_1 = require("react-i18next");
const YoullEarnMsg_1 = require("../../bonus-points/YoullEarnMsg");
const config_1 = require("../../config/config");
const RestrictionMessage_1 = require("../../message-alert/RestrictionMessage");
const SurveyScreenStyle_1 = require("../jss/SurveyScreenStyle");
const MultiSelectQuestion_1 = require("./MultiSelectQuestion");
const SingleSelectQuestion_1 = require("./SingleSelectQuestion");
const TextQuestion_1 = require("./TextQuestion");
const SurveyContent = ({ survey, playerResponses, isSystemSurvey, classes, isLoading, onChange, onSaveSurvey, bonusPoints, amount, limitReached, quizResponse, isLoggedIn, t, showSignInWarning, showSummaryAnswers, isRestricted, theme, handleContactUs, logAnalytics }) => {
    const isValid = () => {
        let valid = true;
        const validResponses = playerResponses
            ? playerResponses.filter((response) => isQuestionResponseValid(response)).length
            : 0;
        const requiredResponses = survey.questions.filter((response) => !response.optional).length || 0;
        if (!playerResponses || validResponses < requiredResponses) {
            valid = false;
        }
        else {
            survey.questions
                .filter((question) => !question.optional)
                .forEach((question) => {
                const responses = playerResponses.filter((response) => response.questionId === question.id);
                if (responses.length > 0) {
                    const response = responses[0];
                    if (!isQuestionResponseValid(response)) {
                        valid = false;
                    }
                }
                else {
                    valid = false;
                }
            });
        }
        return valid;
    };
    const isQuestionResponseValid = (response) => response.responseText || (response.options && response.options.length > 0);
    const setResponse = (answer) => {
        onChange(answer);
    };
    const onTextQuestionChange = (question, value) => {
        setResponse({ questionId: question.id, responseText: value });
        if (logAnalytics)
            logAnalytics('0174', value !== null && value !== void 0 ? value : '');
    };
    const onSingleSelectQuestionChange = (question, value) => {
        if (value)
            setResponse({ questionId: question.id, options: [value.id] });
    };
    const onMultiSelectQuestionChange = (question, value) => {
        if (value) {
            setResponse({
                questionId: question.id,
                options: value.map(x => x.id)
            });
        }
    };
    const onSave = () => {
        if (isValid()) {
            onSaveSurvey();
        }
    };
    const getQuestion = (question, index) => {
        const response = quizResponse === null || quizResponse === void 0 ? void 0 : quizResponse.find(r => r.questionId === question.id);
        switch (question.questionType) {
            case types_1.QuestionType.SINGLE_SELECT:
                const answer = findResponse(question);
                const surveyOption = question.options && answer
                    ? question.options.find((option) => option.id === answer[0])
                    : null;
                return ((0, jsx_runtime_1.jsx)(SingleSelectQuestion_1.default, { questionIndex: index, groupName: question.id.toString(), onChange: onSingleSelectQuestionChange, question: question, answer: surveyOption, quizResponse: response, showSummaryAnswers: showSummaryAnswers, quizType: survey.quizConfig, logAnalytics: logAnalytics }, question.id));
            case types_1.QuestionType.MULTI_SELECT:
                return ((0, jsx_runtime_1.jsx)(MultiSelectQuestion_1.default, { questionIndex: index, onChange: onMultiSelectQuestionChange, question: question, surveyOptions: findMultiResponse(question), quizResponse: response, showSummaryAnswers: showSummaryAnswers, quizType: survey.quizConfig, logAnalytics: logAnalytics }, question.id));
            case types_1.QuestionType.FREE_RESPONSE:
                return ((0, jsx_runtime_1.jsx)(TextQuestion_1.default, { questionIndex: index, onChange: onTextQuestionChange, question: question, answer: findResponse(question) }, question.id));
            default:
                return null;
        }
    };
    const findResponse = (question) => {
        const data = playerResponses ? playerResponses.find(x => x.questionId === question.id) : null;
        return (data === null || data === void 0 ? void 0 : data.responseText) || (data === null || data === void 0 ? void 0 : data.options) || null;
    };
    const findMultiResponse = (question) => {
        var _a;
        const answer = playerResponses ? playerResponses.find(x => x.questionId === question.id) : null;
        if (answer && answer.options && answer.options.length > 0) {
            return (((_a = question.options) === null || _a === void 0 ? void 0 : _a.filter((option) => answer.options &&
                answer.options.find((item) => item.toString() === option.id.toString()))) || []);
        }
        return [];
    };
    const getQuestions = () => {
        const { questions } = survey;
        return questions.map((question, index) => getQuestion(question, index));
    };
    return ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: 3, direction: "column" }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, container: true, xs: 12, style: { flex: '1 1 auto' } }, { children: getQuestions() })), !isSystemSurvey && ((0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", component: 'span', gutterBottom: true, className: classes.surveyAnswer }, { children: survey.questions.length === 1 ? t('survey.answerAll') : t('survey.answerAllMultiple') }))), isRestricted && ((0, jsx_runtime_1.jsx)(RestrictionMessage_1.default, { sx: {
                    margin: 'auto',
                    marginBottom: theme.spacing(3)
                }, handleContactUs: handleContactUs })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ disabled: (showSignInWarning && !isLoggedIn) ||
                    isRestricted ||
                    !isValid() ||
                    isLoading ||
                    (limitReached && survey && !survey.updateResponses), size: "large", variant: "contained", color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: onSave, "aria-label": 'Submit', className: (0, classnames_1.default)(classes.surveyBtn, 'containedButton') }, { children: isSystemSurvey ? t('survey.save') : t('survey.submit') })), !limitReached && !isSystemSurvey && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, style: { display: 'flex', justifyContent: 'center' } }, { children: (0, jsx_runtime_1.jsx)(YoullEarnMsg_1.default, { bonusPoints: bonusPoints, noneBonusPoints: amount }) })))] })));
};
exports.default = (0, styles_1.withTheme)((0, styles_1.withStyles)(SurveyScreenStyle_1.default)((0, react_i18next_1.withTranslation)()(SurveyContent)));
//# sourceMappingURL=SurveyContent.js.map